import * as constants from './../constants';

const initialState = true;

const loadingReducer = (state = initialState, { type }) => {
  switch (type) {
    case constants.INITIAL_DATA.REQUEST:
      return true;
    case constants.INITIAL_DATA.SUCCESS:
    case constants.INITIAL_DATA.FAILURE:
      return false;
    default:
      return state;
  }
};

export default loadingReducer;
export { initialState };
